














































import { Component, Vue, Watch} from 'vue-property-decorator'
import iView from 'iview';
import Ajax from '../../../lib/ajax'
import AbpBase from '../../../lib/abpbase'
@Component({
    name:'contractDetailMoney'
})
export default class ContractDetailMoney extends AbpBase  {
    initData:any = {
        id: null,
        receivables: {
            contract: {}
        },
        tableTitle: [
            {
                title: '收款日期',
                key: 'amountDt',
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, params.row.amountDt ? params.row.amountDt.substring(0, 10) : '')
                    ])
                }
            },
            {
                title: '收款金额（元）',
                key: 'amount',
                align: 'center'
            },
            {
                title: '资质管理费计提比例',
                key: 'calRatio',
                align: 'center'
            },
            {
                title: '资质管理费计提金额（元）',
                key: 'calAmount',
                align: 'center'
            },
            {
                title: '备注',
                key: 'remark',
                align: 'center'
            },
            {
                title: '操作',
                key: 'action',
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    this.Edit(params.row);
                                }
                            }
                        }, '编辑')
                    ]);
                }
            }
        ],
        tableLoading: true,
        modalData: {
            isShow: false,
            calRatio:null,
            calRatioAmount:null,
            btnLoading:true
        }
    }
    //显示弹窗
    async AddContractMoney() {
        (this as any).$refs.addForm.resetFields();
        await this.GetCalRatio();
        this.initData.modalData.isShow = true;
        this.initData.submitType = 'add';
    }
    //获取计提比例
    async GetCalRatio() {
        this.initData.modalData.calRatio = (await Ajax.get('/api/services/app/ProjectManager/GetProjectCatalogAsync?id=' + this.initData.projectCatalogId)).data.result.qmCalRatioDefault;
    }
    //设置资质管理费计提金额
    async CalculateCalAmount() {
        if(this.initData.modalData.amount == undefined) return;
        let data:any = {
            amount: this.initData.modalData.amount,
            calRatio: this.initData.modalData.calRatio
        }
        await Ajax.post('/api/services/app/Contract/CalculateCalAmountAsync', data).then( (res:any) => {
            this.$set(this.initData.modalData, 'calRatioAmount',res.data.result);
        } )
        // this.$set(this.initData.modalData, 'calRatioAmount', (await Ajax.post('/api/services/app/Contract/CalculateCalAmountAsync', data)).data.result);
    }
    //提交合同收款与资质管理费计提
    async CreateContractReceipt() {
        this.initData.modalData.contractId = ~~this.initData.id;
        (this as any).$refs.addForm.validate( async (valid:any) => {
            if(valid){
                if(this.initData.submitType == 'add'){
                    await Ajax.post('/api/services/app/Contract/CreateContractReceiptAsync', this.initData.modalData).then(()=>{
                        this.$Message.success('填报成功!');
                        this.GetData();
                        this.initData.modalData.isShow = false;
                    })
                }else{
                    await Ajax.put('/api/services/app/Contract/UpdateContractReceiptAsync', this.initData.modalData).then(()=>{
                        this.$Message.success('修改成功!');
                        this.GetData();
                        this.initData.modalData.isShow = false;
                    })
                }
            }else{
                setTimeout(() => {
                    this.initData.modalData.btnLoading = false;
                    this.$nextTick(() => {
                        this.initData.modalData.btnLoading = true;
                    });
                }, 1000);
            }
        } )
        
    }

    //获取收款数据
    async GetData() {
        this.initData.receivables = (await Ajax.get('/api/services/app/Contract/GetAllContractReceiptAsync?ContractId=' + this.initData.id)).data.result;
        this.initData.tableLoading = false;
    }
    //编辑
    async Edit(data:any) {
        this.initData.modalData.isShow = true
        this.initData.modalData.amount = data.amount;
        this.initData.modalData.amountDt = new Date(data.amountDt);
        this.initData.modalData.calRatio = data.calRatio;
        this.initData.modalData.calRatioAmount = data.calAmount;
        this.initData.modalData.remark = data.remark;
        this.initData.modalData.id = data.id;
        this.initData.submitType = 'edit';
    }

    async mounted() {
        this.initData.id = this.$route.query.id;
        this.initData.contractName = this.$parent.$data.contractName;
        this.initData.projectCatalogId = this.$parent.$data.projectCatalogId;
        //处理用户数据回调慢问题
        if(!this.$store.state.session.user){
            await this.$store.dispatch({type: 'session/init'});
        }
        this.initData.userName = this.$store.state.session.user.name;
        this.initData.organization = this.$store.state.session.user.organization.displayName;
        this.GetData();
    }
    //计算属性
    @Watch('initData.modalData.calRatio')
    calRatioMoey(newVal:any){
        if(!newVal){
            this.initData.modalData.calRatioAmount = 0;
            return;
        }
        this.initData.modalData.calRatio = newVal;
        this.CalculateCalAmount();//重新计算金额
    }
    rulesForm:any ={
        amount:[{ required: true, type:'number', message: '收款金额必填', trigger: 'blur' }],
        amountDt:[{ required: true, type:'date', message: '收款日期必填', trigger: 'change' }],
        calRatio:[{ required: true, type:'number', message: '资质管理费计提比例必填', trigger: 'blur' }],
        calRatioAmount:[{ required: true, type:'number', message: '资质管理费计提金额必填', trigger: 'blur' }],
    }

}
